import React from 'react';
import './App.css';
import Form from "./Form";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <Form/>
      </header>
    </div>
  );
}

export default App;
